import React from 'react';
import { CardUserRequestProps } from './types';
import { CardUserFinder } from '@entities/user/ui/card-user-request/card-user-request';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { CounterRequestsInOrder } from '@features/request/counter-requests-in-order/ui/counter-requests-in-order';
import { useUpdateRequestQuantityMutation } from '@features/request/counter-requests-in-order/api/counter-requests-in-order-api';
import { CACHE_KEY_MANAGER_UPDATE_QUANTITY_REQUEST } from '@features/request/counter-requests-in-order/config/api-constants';
import { DeclineManagerRequestInOrder } from '@features/request/decline-manager-request-in-order/ui/decline-manager-request-in-order';
import { useCreateRequestForNewEmployeeInOrderMutation } from '@features/request/create-employee-request-in-order/api/create-employee-request-in-order-api';
import { CACHE_KEY_REQUEST_CREATE } from '@features/request/decline-manager-request/config/api-constants';

export const CardUserRequest: React.FC<CardUserRequestProps> = ({
    request,
    order,
    isLastRequest,
    onUpdateCount,
    onRemoveUser,
    onClick,
}) => {
    const user = request.user;
    const [, updateRequestResult] = useUpdateRequestQuantityMutation({
        fixedCacheKey: `${CACHE_KEY_MANAGER_UPDATE_QUANTITY_REQUEST}_${request.id}`,
    });

    const [, createRequestResult] = useCreateRequestForNewEmployeeInOrderMutation({
        fixedCacheKey: `${CACHE_KEY_REQUEST_CREATE}_${user.id}`,
    });

    const isLoading = updateRequestResult.isLoading || createRequestResult.isLoading;

    return (
        <CardUserFinder
            key={request.id}
            isLoading={isLoading}
            avatarUrl={user.photoUrl}
            userName={userName({ ...user }).full}
            jobTitle={user.jobTitle}
            onClick={onClick}>
            <CounterRequestsInOrder request={request} order={order} onUpdateCount={onUpdateCount} />
            <div onClick={(e) => e.stopPropagation()}>
                <DeclineManagerRequestInOrder
                    isLastRequest={isLastRequest}
                    request={request}
                    order={order}
                    onSuccess={onRemoveUser}
                />
            </div>
        </CardUserFinder>
    );
};
